<button mat-mini-fab color="primary" (click)="openSearchModal()" matTooltip="Search Roadmaps" matTooltipPosition="below">
  <mat-icon>search</mat-icon>
</button>
